export const GENDER = [
    {label: 'Female', _id: '507f1f77bcf86cd799439081'},
    {label: 'Male', _id: '507f1f77bcf86cd799439082'},
    {label: 'Transgender', _id: '507f1f77bcf86cd799439083'},
    {label: 'Other', _id: '507f1f77bcf86cd799439085'},
    {label: 'Prefer Not to Answer', _id: '507f1f77bcf86cd799439086'},
];
